import script from "./CommentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentForm.vue?vue&type=script&setup=true&lang=js"

import "./CommentForm.vue?vue&type=style&index=0&id=16e86798&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e86798"]])

export default __exports__